module.exports = __webpack_public_path__ + "static/media/mortar-pestle.4afff458.svg";